import './bootstrap';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic/build/ckeditor';

import $ from 'jquery';
window.$ = window.jQuery = $;

import Noty from 'noty';
window.ClassicEditor = ClassicEditor;

